import { render, staticRenderFns } from "./SwitcherEx.vue?vue&type=template&id=754f5254&shadow"
import script from "./SwitcherEx.vue?vue&type=script&lang=js&shadow"
export * from "./SwitcherEx.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports